import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionMenuCatalogFetchListPayload,
	IActionMenuCatalogFetchListPayloadDone,
	IActionMenuCatalogFetchListPayloadError,
} from './types';

export const menuCatalogFetchList = actionCreatorAsync<
	IActionMenuCatalogFetchListPayload,
	IActionMenuCatalogFetchListPayloadDone,
	IActionMenuCatalogFetchListPayloadError
>(
	'menuCatalogFetchList',
	async () => {
		const { data } = await Api.menuCatalog.fetchList({});

		return data;
	},
);
